import { render, staticRenderFns } from "./extendTable.vue?vue&type=template&id=e5dcdca0&scoped=true"
import script from "./extendTable.vue?vue&type=script&lang=js"
export * from "./extendTable.vue?vue&type=script&lang=js"
import style0 from "./extendTable.vue?vue&type=style&index=0&id=e5dcdca0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5dcdca0",
  null
  
)

export default component.exports